/*@ngInject*/
const EndorsementActionsRepository = function ($q, baseSharedPromiseRepository, currentSubmissionModel) {

    var sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.loadEndorsementActions = function (endorsementId) {
        var url = '/rest/Actions?uri=com.firstbest.underwriting.policy.endorsement.Endorsement:' + endorsementId + '&registrationIdentifier=/Endorsement/' + endorsementId,
            cacheKey = 'endorsementActions:' + endorsementId;

        if (currentSubmissionModel.hasActionsRegistration('/Endorsement/' + endorsementId)) {
            return $q.resolve(null);
        } else {
            return this.get(cacheKey, url).then(function (responseData) {
                currentSubmissionModel.addActionsRegistration('/Endorsement/' + endorsementId, url);
                return responseData;
            });
        }
    };
};

angular.module('gw-um-submission')
    .service('endorsementActionsRepository', EndorsementActionsRepository);
